function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import Translate from "../../../common/translation";
import Icon from "../../../common/icon";
import DraggableItem from "./dnd-element";

/**
 * Complex type
 *
 * List of response
 *
 */
var DndList = function DndList(props) {
  var index = props.index,
    elements = props.elements,
    setElements = props.setElements,
    creationMode = props.creationMode,
    setUpdateMode = props.setUpdateMode,
    onDeleteElement = props.onDeleteElement,
    create = props.create;
  function handleOnDragEnd(result) {
    if (!result.destination) return;
    var destination = elements[result.destination.index];
    elements[result.destination.index] = elements[result.source.index];
    elements[result.source.index] = destination;
    setElements(elements);
  }
  if (!elements) {
    return 'No elements';
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "8",
    sm: "9",
    className: "text-left text-uppercase font-weight-bold"
  }, /*#__PURE__*/React.createElement(Translate, {
    id: "collector_list_mode",
    className: ""
  }), " ", !create ? index | '' : null), /*#__PURE__*/React.createElement(Col, {
    md: "4",
    sm: "3",
    className: "text-right"
  }, creationMode ? null : /*#__PURE__*/React.createElement(Button, {
    type: "button",
    color: "default",
    className: "text-dark-pink",
    onClick: setUpdateMode
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "pen"
  }), " ", /*#__PURE__*/React.createElement(Translate, {
    id: "collector_edit"
  })))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12"
  }, /*#__PURE__*/React.createElement(DragDropContext, {
    onDragEnd: handleOnDragEnd
  }, /*#__PURE__*/React.createElement(Droppable, {
    droppableId: "dndList"
  }, function (provided) {
    return /*#__PURE__*/React.createElement("ul", _extends({
      className: "collectorDndList"
    }, provided.droppableProps, {
      ref: provided.innerRef
    }), Object.keys(elements).map(function (key) {
      var element = elements[key];
      return element && /*#__PURE__*/React.createElement(DraggableItem, {
        key: "".concat(element.id, "_").concat(key, "_").concat(index),
        id: element.id,
        element: element,
        index: parseInt(key),
        onDelete: function onDelete() {
          return onDeleteElement(key, index);
        }
      });
    }), provided.placeholder);
  })))));
};
DndList.propTypes = {
  setElements: PropTypes.func,
  elements: PropTypes.shape({}),
  creationMode: PropTypes.bool,
  create: PropTypes.bool,
  onDeleteElement: PropTypes.func.isRequired
};
DndList.defaultProps = {
  elements: {},
  setElements: null,
  creationMode: false,
  create: false
};
export default DndList;